import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import type { AdItem } from '@sbt-web/network/types';
import { LoadingSkeleton } from '@sbt-web/ui';
import useUser from '@/client/contexts/UserContext';
import { getSearchValue } from '../../utils';
import { ContactButton } from './ContactButton';
import { PhoneButton } from './PhoneButton';
import classes from './index.module.scss';
export type AdReplyButtonsProps = {
  isMobile: boolean;
  contactAsSecondaryButton?: boolean;
  adUrn: string;
  showPhone: boolean;
  item: AdItem;
};
export const AdReplyButtons = t0 => {
  const $ = _c(20);
  const {
    isMobile,
    contactAsSecondaryButton,
    adUrn,
    showPhone,
    item
  } = t0;
  const {
    user
  } = useUser();
  const [hasMounted, setHasMounted] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getSearchValue();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const searchValue = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasMounted(true);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!hasMounted) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoadingSkeleton className={classes.skeleton} themed={true} />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  if (!user && showPhone) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ContactButton isSecondary={true} showLabel={false} showIcon={true} />;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        name: "Mostra Numero",
        pageType: "ad_detail"
      };
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== adUrn || $[7] !== isMobile || $[8] !== item) {
      t6 = <div className={classes.switchedTouchPoints}>{t4}<PhoneButton adUrn={adUrn} isMobile={isMobile} search={searchValue} item={item} buttonLabelDesktop="Mostra numero" buttonLabelMobile="Mostra numero" buttonDesign="solid" buttonSize="large" pulseEvent={t5} /></div>;
      $[6] = adUrn;
      $[7] = isMobile;
      $[8] = item;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t4;
  if ($[10] !== adUrn || $[11] !== isMobile || $[12] !== item || $[13] !== showPhone) {
    t4 = showPhone && <PhoneButton adUrn={adUrn} isMobile={isMobile} search={searchValue} item={item} buttonDesign="outline" buttonSize="large" pulseEvent={{
      name: "Mostra Numero",
      pageType: "ad_detail"
    }} />;
    $[10] = adUrn;
    $[11] = isMobile;
    $[12] = item;
    $[13] = showPhone;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== contactAsSecondaryButton) {
    t5 = <ContactButton isSecondary={contactAsSecondaryButton} />;
    $[15] = contactAsSecondaryButton;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};